import { EventBus } from "ts-bus";
export const eventBus = new EventBus();